import { render, staticRenderFns } from "./AptitudeChart.vue?vue&type=template&id=f8c99528"
import script from "./AptitudeChart.vue?vue&type=script&lang=js"
export * from "./AptitudeChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports